export interface PermanentScarringOrDisfigurement {
	isPermanentScarringOrDisfigurementPresent: boolean;
}

export const defaultPermanentScarringOrDisfigurement: PermanentScarringOrDisfigurement =
	{
		isPermanentScarringOrDisfigurementPresent: false,
	};
